import { RouterEffects } from './router.effect';

export const effects: any[] = [RouterEffects];

export * from './router.effect';



// WEBPACK FOOTER //
// /vercel/path0/src/app/store/effects/index.ts